import { WorkspaceRoleSchema } from "../workspace";
import { z } from "zod";
export const PersonalAccessToken = z.object({
    id: z.string(),
    userId: z.string(),
    workspaceId: z.string().optional(),
    designSystemId: z.string().optional(),
    workspaceRole: WorkspaceRoleSchema.optional(),
    name: z.string(),
    hidden: z.boolean(),
    token: z.string(),
    scope: z.string().optional(),
    createdAt: z.coerce.date(),
    expireAt: z.coerce.date().optional(),
});
